
import { InterpolationWithTheme } from "@emotion/core";
import { css } from 'emotion';

export const DefaultWorkingHoursStyles: { [key: string]: InterpolationWithTheme<any> } = {
    outerContainer: {
        padding: "0px 10px 10px 0px"
    },
    header: {
        position: "relative",
        color: "rgb(255, 49, 109)",
        fontFamily: "BrandonTextWeb-Medium",
        fontSize: "16px"
    },
    backArrow: {
        height: "15px",
        cursor: "pointer",
        position: "absolute",
        top: "3px"
    },
    headerTitle: {
        fontFamily: "BrandonTextWeb-Bold",
        fontSize: "18px",
        margin: "0px 20px"
    },
    subHeader: {
        display: "flex",
        margin: "30px 20px"
    },
    subTitle: {
        color: "rgb(0, 0, 0)",
        fontFamily: "BrandonTextWeb-Medium",
        fontSize: "14px",
        marginLeft: "20px"
    },
    workingHoursDescriptionWrapper: {
        background: "rgba(222, 236, 253, 0.5)",
        borderRadius: "5px",
        padding: "30px",
        display: "flex",
        flexDirection: "row",
        lineHeight: "49px"
    },
    workingHoursDescriptionWrapperMobile: {
        background: "rgba(222, 236, 253, 0.5)",
        borderRadius: "5px",
        padding: "4%",
        display: "flex",
        flexDirection: "column",
        margin: "10px"
    },
    description: {
        marginLeft: "40px"
    },
    heading: {
        fontFamily: "BrandonTextWeb-Medium",
        fontSize: "20px",
        marginBottom: "10px"
    },
    listWrapper: {
        paddingLeft: "16px"
    },
    listItems: {
        fontFamily: "BrandonTextWeb-Regular",
        fontSize: "25px",
        color: "rgb(228, 48, 110)"
    },
    listLabel: {
        color: "black",
        fontSize: "18px"
    },
    mobilePageHeader: {
        position: "relative",
        marginBottom: "13px",
        marginLeft: "11px",
        marginTop: "13px"
    },
    defaultHoursImage: {
        height: "43px",
        margin: "15px"
    },
    mobileDescription: {
        marginLeft: "0"
    },
    backNav: {
        background: "rgb(255, 255, 255)",
        borderRadius: "0px",
        boxShadow: "0px 7px 5px 0px rgba(220, 233, 242, 0.37)",
        padding: "20px"
    }
}
